export function isRequestTimeoutError(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) {
    return false;
  }

  const name = 'name' in error ? error.name : undefined;
  const message =
    'message' in error && typeof error.message === 'string'
      ? error.message
      : '';

  return name === 'TimeoutError' || message.startsWith('Request timed out:');
}
